import loadable from '@loadable/component';

export const CartContainerLoadable = loadable(() => import('./CartContainer'), {
  resolveComponent: (module) => module.CartContainer,
});
